import http from '@services/http';

export default {
    uploadWebEvents(params: IRecordStore.IUploadParams): Promise<any> {
        return http.post('/reports/uploadWebEvents', params || {});
    }
};
